import { gql } from '@apollo/client';

import SellerInputFragment from '../fragments/sellerInputFragment';

const verifyAddressMutation = gql`
  mutation VerifyAddress($sellerInputUUID: String!) {
    reception {
      verifySellerAddress(input: { uuid: $sellerInputUUID }) {
        sellerInput {
          ...SellerInputFragment
        }
      }
    }
  }
  ${SellerInputFragment}
`;

export default verifyAddressMutation;
